import { Handle, Position } from "@xyflow/react";

const LabeledHandle = ({ id, title, type, position, className, labelClassName, isConnected }) => {
  return (
    <div className={`relative flex items-center ${className}`}>
      {position === Position.Left && isConnected && (
        <Handle
          type={type} // This should match the edge's targetHandle
          position={Position.Left}
          id={id} // This should match the edge's sourceHandle or targetHandle
          style={{ pointerEvents: "none" }}
        />
      )}
      <span className={`mx-2 ${labelClassName}`}>{title}</span>
      {position === Position.Right && isConnected && (
        <Handle
          type={type} // This should match the edge's sourceHandle
          position={Position.Right}
          id={id} // This should match the edge's sourceHandle or targetHandle
          style={{ pointerEvents: "none" }}
        />
      )}
    </div>
  );
};

export default LabeledHandle;
